import { BuildWebITProps } from "@/types/build_we_it/buildWebIT.type";

export const buildWebITData: BuildWebITProps = {
  // email: "buildweb.it@gmail.com",
  email: "hello@buildweb-it.com",
  infoEmail: "info@buildweb-it.com",
  phone: "+8801885675771",
  facebookLink: "https://www.facebook.com/buildwebit",
  linkedinLink: "https://www.linkedin.com/company/buildwebit",
  whatsappLink: "https://wa.me/+8801885675771"
}